var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGauffre(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F8CD8B",
    d: "m11.154 50.725 4.029 7.775a6.492 6.492 0 0 0 5.764 3.5A6.48 6.48 0 0 0 23 61.667l22.048-7.929 7.34-2.638 6.312-2.274a3.472 3.472 0 0 0 2.3-3.267 3.472 3.472 0 0 0-1.165-2.595l-4.658-4.14z",
    opacity: 1,
    "data-original": "#f8cd8b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3A947",
    d: "M20.233 56a4.591 4.591 0 0 1-4.127-2.55l-.919-1.84a.9.9 0 0 1-.052-.124l-1.081-3.163 1.892-.646 1.06 3.1.89 1.78a2.659 2.659 0 0 0 3.4 1.218l5.618-2.5 3.573-2.135 1.026 1.716-3.625 2.167a1.088 1.088 0 0 1-.107.056L22.107 55.6a4.61 4.61 0 0 1-1.874.4z",
    opacity: 1,
    "data-original": "#f3a947"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4B860",
    d: "m6.7 35.121-3.286 7.886A5.381 5.381 0 0 0 3 45.076a5.381 5.381 0 0 0 4.9 5.36L48 54a4.768 4.768 0 0 0 4.7-3.939l1.962-11.116z",
    opacity: 1,
    "data-original": "#f4b860"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3A947",
    d: "M47 39.324v4.605L21.943 42.2l-.136 2 25.415 1.753 2.137 7.836a4.753 4.753 0 0 0 1.8-1L49 44.866v-5.542z",
    opacity: 1,
    "data-original": "#f3a947"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8CD8B",
    d: "m5 14 2.178 27.068A5.9 5.9 0 0 0 13 46l41-7a4 4 0 0 0 4-4l-9-24a3.618 3.618 0 0 0-3.236-2L8 11a3 3 0 0 0-3 3z",
    opacity: 1,
    "data-original": "#f8cd8b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3A947",
    d: "m57.929 35.708-4.045-5.2L45.819 9h-.055l-2.042.108 1.2 3.188-6.708.491-1.23-3.322-2.091.111 1.245 3.362-6.745.494-.88-3.518-2.034.108.89 3.558-7.96.582-.721-3.728-2.016.107.729 3.768-6.168.452-.488-3.906-2 .106 3.235 25.883-3.302 7.247a5.9 5.9 0 0 0 1.633 1.24l3.375-7.423 38.884-5.832 4.369 5.618a3.975 3.975 0 0 0 .99-1.986zm-8.313-10.884-6.628.865-1.532-4.136 6.667-.709zM45.65 14.248l1.75 4.661-6.659.708-1.808-4.877zm-8.793.643 1.831 4.945-7.5.8L29.88 15.4zm-9 .659 1.324 5.3-8.312.884-1.082-5.594zm-16.381 1.2 6.3-.461 1.095 5.657-6.66.708zm.986 7.889 6.793-.722.919 4.75-7.093.925zm1.4 11.222-.535-4.285 7.225-.942.8 4.1zM21.251 23.7l8.42-.9 1.118 4.473-8.628 1.125zm2.078 10.737-.787-4.066 8.736-1.14.967 3.869zm8.349-11.846 7.727-.822 1.549 4.183-8.169 1.068zM34.231 32.8l-.958-3.831 8.393-1.095L43 31.488zm10.792-1.619L43.7 27.613l6.637-.866 1.293 3.447z",
    opacity: 1,
    "data-original": "#f3a947"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F4B860"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m38.826 12.746-.843-2.275 6.129-.328-.389-1.032-6.74.36 1.23 3.32zM30.129 13.377l-.616-2.456 5.761-.307-.381-1.033-6.38.34.88 3.51zM20.198 14.103l-.515-2.662 7.05-.38-.26-1.04-7.79.42.72 3.72zM11.743 11.861l5.132-.277-.202-1.043-5.93.32.49 3.9.867-.063zM50.746 27.828l-.403-1.077-6.64.86 1.32 3.58.598-.09-.918-2.49zM48.524 21.914l-.401-1.063-6.66.7 1.53 4.14.602-.078-1.132-3.062zM46.045 15.295l-.392-1.044-6.72.49 1.81 4.88.605-.065-1.415-3.815zM31.923 20.554l-1.04-4.153 6.366-.465-.386-1.045-6.98.51 1.31 5.23zM33.511 26.926l-.828-3.335 7.114-.756-.394-1.064-7.72.82 1.1 4.43zM42.07 28.959l-.397-1.078-8.4 1.09.96 3.84.723-.109-.683-2.731zM31.555 30.326l-.272-1.095-8.74 1.14.79 4.07.783-.118-.573-2.952zM22.95 28.308l-.697-3.607 7.69-.813-.27-1.077-8.42.89.91 4.71zM28.126 16.605l-.263-1.054-8.07.59 1.08 5.59.791-.084-.871-4.506zM12.483 17.751l5.504-.402-.204-1.058-6.3.46.73 5.9.865-.092zM13.463 25.641l6.008-.636-.208-1.084-6.8.72.62 4.95.861-.112zM20.775 31.734l-.212-1.103-7.23.95.53 4.28.86-.129-.39-3.151z",
    fill: "#F4B860",
    opacity: 1,
    "data-original": "#f4b860"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C33E37",
    d: "M32.345 6.437A5.266 5.266 0 0 0 30 10.819a5.268 5.268 0 0 0 1.543 3.724l3.414 4.181A3.477 3.477 0 0 0 37.648 20a3.472 3.472 0 0 0 3.225-2.184A15.748 15.748 0 0 0 42 11.967V10.3a4.3 4.3 0 0 0-1.916-3.58A4.3 4.3 0 0 0 37.7 6h-3.91a2.6 2.6 0 0 0-1.445.437z",
    opacity: 1,
    "data-original": "#c33e37"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#447B3B",
    d: "M36 7a1 1 0 0 1-.8-.4l-.6-.8A7.035 7.035 0 0 0 29 3V1a9.05 9.05 0 0 1 6.272 2.548A4.007 4.007 0 0 1 39 1v2a2 2 0 0 0-2 2v1a1 1 0 0 1-.684.949A1.014 1.014 0 0 1 36 7z",
    opacity: 1,
    "data-original": "#447b3b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DD5E56",
    d: "M34 6a16.937 16.937 0 0 0 1.789 7.578L37 16l1.2-2.409a7.536 7.536 0 0 0 .8-3.37 7.535 7.535 0 0 0-.386-2.382L38 6",
    opacity: 1,
    "data-original": "#dd5e56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 18,
    r: 4,
    fill: "#8232A3",
    opacity: 1,
    "data-original": "#8232a3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#447B3B",
    d: "m50.582 22.415.366-1.1-1.9-.632-.366 1.1a1.959 1.959 0 0 1-1.747 1.34l.061 1-.685.729A5.362 5.362 0 0 1 48 28.744V30h2v-1.256a7.369 7.369 0 0 0-1.265-4.108 3.95 3.95 0 0 0 1.847-2.221z",
    opacity: 1,
    "data-original": "#447b3b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 22,
    r: 3,
    fill: "#9F51B7",
    opacity: 1,
    "data-original": "#9f51b7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E15240",
    d: "M41.216 29a5.351 5.351 0 0 1-3.783-1.567l-1.749-1.749A5.751 5.751 0 0 1 34 21.618a2.618 2.618 0 0 1 1.447-2.342A2.631 2.631 0 0 1 36.618 19h5.261a5.122 5.122 0 0 1 3.621 1.5 5.122 5.122 0 0 1 1.5 3.621 3.757 3.757 0 0 1-1.5 3.006l-1.07.8A5.355 5.355 0 0 1 41.216 29z",
    opacity: 1,
    "data-original": "#e15240"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DD5E56",
    d: "M41.879 19h-5.261a2.355 2.355 0 0 0-1.613.581c0 .013-.005.024-.005.037a5.751 5.751 0 0 0 1.684 4.066l1.749 1.749a5.351 5.351 0 0 0 6.994.5l1.07-.8a3.672 3.672 0 0 0 .433-.412 3.677 3.677 0 0 0 .07-.594A5.121 5.121 0 0 0 41.879 19z",
    opacity: 1,
    "data-original": "#dd5e56"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGauffre);
export default __webpack_public_path__ + "static/media/Gauffre.66d121a95bbcb986c361fcf39988adad.svg";
export { ForwardRef as ReactComponent };